import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
  body * {
    overflow-wrap: break-word;
  }

  fieldset {
    // fieldsets by default have a min-width: min-content
    // this change allows overflow-wrap: word-break to work correctly
    min-width: auto; 
  }

  a {
    text-decoration: underline;
  }
  `
